export const resetAddToCartButtonText = (buttonIndex) => {
  $(`#addToCart_${buttonIndex}`)
    .removeClass('added-to-cart')
    .find('.button__text')
    .text('Add to bag');
};
